const COPY_SELECTOR = ".js-copy";
const COPY_TEXT_SELECTOR = ".js-copy__text";
const COPY_BTN_SELECTOR = ".js-copy__btn";
const COPIED_CLASS = "copied";

const COPY_DELAY = 1000;

export const initCopyBtn = () => {
    const copyBlocks = document.querySelectorAll(COPY_SELECTOR);
    Array.from(copyBlocks).forEach(initCopyElements);
};

/**
 * Copies text by btns click
 *
 * 1. If the @el is the btn with btnText with text to copy
 * 2. If there are buttons located outside the @el (by @el ID)
 * 3. If there are inner buttons, located in the @el
 */

const initCopyElements = (el) => {
    let timerId = null;

    // Find buttons that copy text, located outside the parent
    const btnId = el.dataset.copyBtn;
    let btns = null;
    btns = document.querySelectorAll(`[data-copy-btn="${btnId}"]:not(${COPY_SELECTOR})`);
    btns.forEach((btn) => btn.addEventListener("click", copyText));

    // Element with text to copy
    const btnText = el.querySelector(COPY_TEXT_SELECTOR);

    // Btns that copy text, located in the parent
    let innerBtns = el.querySelectorAll(COPY_BTN_SELECTOR);
    let hasInnerBtns = innerBtns.length;

    /**
     * If there are @innerBtns   @btnText click won't work
     * The event listener is transferred to the buttons
     */
    if (hasInnerBtns) {
        innerBtns.forEach((btn) => btn.addEventListener("click", copyText));
    } else {
        btnText.addEventListener("click", copyText);
    }

    async function copyText(e) {
        let target = e.currentTarget;
        let initialTargetText = target.textContent.trim();

        let activeText = target.dataset.active;
        const textToCopy = btnText.textContent;

        try {
            await navigator.clipboard.writeText(textToCopy);
            el.classList.add(COPIED_CLASS);


            clearTimeout(timerId);
            timerId = setTimeout(() => {
                el.classList.remove(COPIED_CLASS);
            }, COPY_DELAY);
        } catch (err) {
            console.error(err);
        }
    }
};

initCopyBtn();